
import  { useState, useRef } from 'react';

function VideoThumb({ src }) {
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [userSeeking, setUserSeeking] = useState(false);

  const handleTimeUpdate = () => {
    if (!userSeeking) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleSeeking = () => {
     setUserSeeking(true);
  };
  
  const handleSeeked = () => {
    setUserSeeking(false);
    if (videoRef.current.currentTime > currentTime) {
      videoRef.current.currentTime = currentTime;
    }
  };

  return (
    <div className='video-container'>
        <video
            ref={videoRef}
            src={src}
            controls={false}
            onTimeUpdate={handleTimeUpdate}
            onSeeking={handleSeeking}
            onSeeked={handleSeeked}
            controlsList='progressbar'
        />
    </div>
  );
}
export default VideoThumb;